export default __webpack_public_path__ + "media/flags/pt-bd78d561.svg";